var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.9L1.11875 9.78125C0.99375 9.90625 0.84375 9.96875 0.66875 9.96875C0.49375 9.96875 0.34375 9.90625 0.21875 9.78125C0.09375 9.65625 0.03125 9.50625 0.03125 9.33125C0.03125 9.15625 0.09375 9.00625 0.21875 8.88125L4.1 5L0.21875 1.11875C0.09375 0.99375 0.03125 0.84375 0.03125 0.66875C0.03125 0.49375 0.09375 0.34375 0.21875 0.21875C0.34375 0.09375 0.49375 0.03125 0.66875 0.03125C0.84375 0.03125 0.99375 0.09375 1.11875 0.21875L5 4.1L8.88125 0.21875C9.00625 0.09375 9.15625 0.03125 9.33125 0.03125C9.50625 0.03125 9.65625 0.09375 9.78125 0.21875C9.90625 0.34375 9.96875 0.49375 9.96875 0.66875C9.96875 0.84375 9.90625 0.99375 9.78125 1.11875L5.9 5L9.78125 8.88125C9.90625 9.00625 9.96875 9.15625 9.96875 9.33125C9.96875 9.50625 9.90625 9.65625 9.78125 9.78125C9.65625 9.90625 9.50625 9.96875 9.33125 9.96875C9.15625 9.96875 9.00625 9.90625 8.88125 9.78125L5 5.9Z",
    fill: "#3D4349"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/IconClose.c4954ce08bd619e3ff348551f4a01085.svg";
export { ForwardRef as ReactComponent };